import React from 'react';
import styles from '../Customize/customize.module.scss';

const CancelPayment = (props) => {
    return (
        <div>
            <div className={styles.profileWrapper} style={{ minHeight: '100%' }}>
                CHECKOUT SESSION WAS CANCELED
            </div>
        </div>
    );
};

export default CancelPayment;
